import React from 'react';
import { type TickerItem } from '../api/types.js';
import { useTranslation } from '../i18n/useTranslation.js';

interface IntelTickerProps {
  tickerItems: Array<TickerItem>;
}

function IntelTicker({ tickerItems }: IntelTickerProps) {
  const { t } = useTranslation();
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="intel-ticker">
      <span className="ticker-label">{t('intelTicker.label')}</span>
      <div className="ticker-track">
        <div className="ticker-inner">
          {doubled.map((item, i) => (
            <div key={i} className="tick-item">
              <span className={`ttype ${item.t}`}>
                {item.t === 'c'
                  ? t('intelTicker.critical')
                  : item.t === 'w'
                  ? t('intelTicker.warning')
                  : item.t === 's'
                  ? t('intelTicker.status')
                  : t('intelTicker.info')}
              </span>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IntelTicker;
